$(document).ready(function(){
  setTimeout(function(){
  $(".banner-slider-list").slick({
      slidesToShow:1,
      slidesToScroll:1,
      fade:true,
      dots:true,
      autoplay:true,
      autoplaySpeed:2000,
      arrows:false
    }).css({
      opacity:"1",
      transition:"opacity 1s ease-in-out"
    })
   },300)
  });